import { render } from "./Endpoints.vue?vue&type=template&id=caeafe5c&scoped=true&ts=true"
import script from "./Endpoints.vue?vue&type=script&lang=ts"
export * from "./Endpoints.vue?vue&type=script&lang=ts"

import "./Endpoints.vue?vue&type=style&index=0&id=caeafe5c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caeafe5c"]])

export default __exports__